import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BECeramicCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Ceramic and Glass Technology",
    shortName: "B.E. Ceramic",
    duration: "4 years",
    description: "Engineering program specializing in ceramic materials, glass technology, and advanced ceramics applications",
    overview: "Bachelor of Engineering in Ceramic and Glass Technology (B.E. Ceramic) is a 4-year undergraduate program that focuses on the science and technology of ceramic and glass materials. This course covers ceramic processing, glass manufacturing, refractories, advanced ceramics, and electronic ceramics, preparing students for careers in ceramics, glass, steel, and high-tech industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in materials science and chemistry"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Ceramics",
          "Materials Science"
        ]
      },
      {
        year: 2,
        subjects: [
          "Inorganic Chemistry",
          "Physical Chemistry",
          "Ceramic Raw Materials",
          "Thermodynamics",
          "Heat and Mass Transfer",
          "Mechanical Engineering"
        ]
      },
      {
        year: 3,
        subjects: [
          "Ceramic Processing",
          "Glass Technology",
          "Refractories",
          "Kiln Technology",
          "Quality Control",
          "Ceramic Design"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Ceramics",
          "Electronic Ceramics",
          "Bioceramics",
          "Environmental Ceramics",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Ceramic Engineer",
        "Materials Engineer",
        "Process Engineer",
        "Quality Control Engineer",
        "R&D Engineer",
        "Production Manager",
        "Technical Consultant",
        "Product Development Engineer",
        "Sales Engineer",
        "Plant Manager"
      ],
      industries: [
        "Steel Industry",
        "Glass Manufacturing",
        "Cement Industry",
        "Refractory Manufacturing",
        "Electronics Industry",
        "Aerospace Industry",
        "Medical Devices",
        "Nuclear Industry",
        "Research Institutions",
        "Government Organizations"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹18-40 LPA (Experienced)",
      topRecruiters: [
        "Tata Steel, SAIL, JSW",
        "Saint-Gobain, Pilkington",
        "ACC Cement, UltraTech",
        "Indian Refractories, IFGL",
        "BHEL, NTPC",
        "DRDO, ISRO"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Government College of Technology",
        location: "Coimbatore",
        fees: "₹2,00,000",
        ranking: "Premier Government College"
      },
      {
        name: "National Institute of Technology",
        location: "Rourkela",
        fees: "₹6,50,000",
        ranking: "NIRF Ranking: 16"
      },
      {
        name: "Indian Institute of Technology",
        location: "Banaras Hindu University",
        fees: "₹8,50,000",
        ranking: "NIRF Ranking: 10"
      },
      {
        name: "Birla Institute of Technology",
        location: "Ranchi",
        fees: "₹12,00,000",
        ranking: "Deemed University"
      }
    ],

    skills: [
      "Ceramic Processing",
      "Glass Manufacturing",
      "Material Characterization",
      "Kiln Operations",
      "Quality Testing",
      "Process Control",
      "CAD Design",
      "Thermal Analysis",
      "X-ray Diffraction",
      "Statistical Analysis"
    ],

    futureScope: "Expanding opportunities in advanced ceramics for electronics, bioceramics for medical implants, aerospace applications, and sustainable ceramic technologies for energy storage.",

    faqs: [
      {
        question: "What industries can ceramic engineers work in?",
        answer: "Steel, glass, cement, electronics, aerospace, medical devices, nuclear, and advanced materials industries offer excellent opportunities for ceramic engineers."
      },
      {
        question: "Is there scope in research and development?",
        answer: "Yes, significant R&D opportunities exist in advanced ceramics, bioceramics, electronic ceramics, and sustainable ceramic technologies in both industry and academia."
      },
      {
        question: "What about government job opportunities?",
        answer: "Government organizations like DRDO, ISRO, BHEL, steel plants, and research institutions actively recruit ceramic engineers for strategic projects."
      },
      {
        question: "Can I work internationally?",
        answer: "Yes, ceramic engineering skills are globally relevant, with opportunities in advanced materials companies, steel plants, and research institutions worldwide."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BECeramicCoursePage;
